module.exports = __webpack_public_path__ + "img/home-sith-new.205e8f44.png";